export class NoConnectionError extends Error {
}

export interface ProblemDetails {
    type: string
    title: string
    status: number
    detail?: string
    instance?: string
}

export class ProblemDetailsError extends Error implements ProblemDetails {
  public readonly type: string
  public readonly title: string
  public readonly status: number
  public readonly detail?: string
  public readonly instance?: string

  constructor(problem: ProblemDetails) {
    super(problem.title)
    this.type = problem.type
    this.title = problem.title
    this.status = problem.status
    this.instance = problem.instance
    this.detail = problem.detail
  }
}

export class NotAuthenticatedError extends ProblemDetailsError {
  constructor() {
    super({
      type: 'UNAUTHORIZED',
      title: 'UNAUTHORIZED',
      status: 401,
      instance: '',
      detail: '',
    })
  }
}

export class NotFoundError extends ProblemDetailsError {
  constructor() {
    super({
      type: 'NOTFOUND',
      title: 'NOTFOUND',
      status: 404,
      instance: '',
      detail: '',
    })
  }
}